const get = require('lodash/get');

const inject = [
  '$scope',
  '$stateParams',
  'requiredFields',
  'paymentService',
  'editPaymentModal',
  'ogsdk.Payment',
  'ogsdk.Address',
  '$q',
  'toastService',
  '$translate',
  'config'
];

function AddPaymentControllerFactory(
  $scope,
  $stateParams,
  requiredFields,
  paymentService,
  editPaymentModal,
  Payment,
  Address,
  $q,
  toastService,
  $translate,
  msiConfig
) {
  class AddPaymentController {
    constructor(_shipment, _requiredFields) {
      this.shipment = _shipment;
      this.requiredFields = _requiredFields;

      this.payment = new Payment({ customerId: msiConfig.auth.sig_field });

      this.payment.billingAddress = new Address({
        addressType: 'billing_address',
        customerId: msiConfig.auth.sig_field
      });

      this.useForAll = true;

      this.requireAllCCFields = {
        ccHolder: true,
        ccType: true,
        ccCardNumber: true,
        ccMonth: true,
        ccYear: true
      };
    }

    submit(payment, useForAll) {
      delete this.error;

      this.submitting = paymentService.create(payment)
        .then(({ publicId }) => editPaymentModal.submit(publicId, useForAll))
        .then(() => toastService.translate.success('TOAST_CHANGE_BILLING_SUCCESS'))
        .then($scope.$close)
        .catch((err) => {
          this.error = get(err, 'error_message', $translate.instant('TOAST_CHANGE_BILLING_DANGER'));
          return $q.reject(err);
        })
        .catch(() => toastService.translate.danger('TOAST_CHANGE_BILLING_DANGER'));

      return this.submitting;
    }
  }

  return new AddPaymentController($stateParams.shipment, requiredFields);
}

AddPaymentControllerFactory.$inject = inject;

angular.module('msi.payments.add')
  .controller('AddPaymentController', AddPaymentControllerFactory);

module.exports = AddPaymentControllerFactory;
